export const noActionStatusThreshold = 10 // days

export type SkapaIconPaths = () => React.SVGProps<SVGElement>[]
